import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { LocalStorageManager } from '../helper/local-storage-manager.helper';

@Injectable()
export class NotAuthGuard {
  constructor(private router: Router) {}

  canActivate(): boolean {
    if (!this.authorized()) {
      return true;
    }

    this.router.navigate(['/']);
    return false;
  }

  authorized(): boolean {
    const LSC = LocalStorageManager.client;

    if (LSC) {
      return LSC.token.refresh !== '';
    }

    return false;
  }
}
